const MODERATION_PATTERNS = [
  { label: "profanity", regex: /\b(?:fuck|fucking|fucker|shit|bullshit|bitch|bastard|asshole|motherfucker|cunt|whore|slut|dickhead|jackass)\b/i },
  { label: "slur", regex: /\b(?:nigg(?:er|a|as)?|fagg(?:ot|ots)?|retard(?:ed)?|spic|kike|chink|gook|wetback)\b/i },
  { label: "sexual_content", regex: /\b(?:porn|porno|pornography|nsfw|xxx|sex(?:ual)?|blowjob|handjob|deepthroat|cumshot|creampie|gangbang|bukkake|milf|bdsm|nude|naked)\b/i },
  { label: "explicit_phrase", regex: /\b(?:suck my dick|eat my pussy|eat dick|get fucked|piece of shit|dumbass|stfu)\b/i },
  { label: "abusive_harassment", regex: /\b(?:go kill yourself|kill yourself|kys|drop dead|hope you die|die in a fire)\b/i },
  { label: "sexual_body_phrase", regex: /\b(?:big tits|nice ass|wet pussy|hard cock)\b/i },
];

export const MODERATION_REJECTION_MESSAGE =
  "This submission was rejected because it contains inappropriate or explicit language.";

export const normalizeModerationText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const moderateText = (value) => {
  const normalized = normalizeModerationText(value);
  if (!normalized) {
    return { ok: true, reason: "", flaggedTerms: [] };
  }

  const flaggedTerms = [];
  for (const pattern of MODERATION_PATTERNS) {
    const match = normalized.match(pattern.regex);
    if (match?.[0]) {
      flaggedTerms.push(match[0]);
    }
  }

  const uniqueTerms = [...new Set(flaggedTerms)];
  return {
    ok: uniqueTerms.length === 0,
    reason: uniqueTerms.length ? "inappropriate_content" : "",
    flaggedTerms: uniqueTerms,
  };
};

export const moderateTextFields = (fields) => {
  for (const [field, value] of Object.entries(fields || {})) {
    const result = moderateText(value);
    if (!result.ok) {
      return {
        ok: false,
        reason: `${field}:${result.reason}`,
        flaggedTerms: result.flaggedTerms,
      };
    }
  }
  return { ok: true, reason: "", flaggedTerms: [] };
};
